import { render, staticRenderFns } from "./ExamChoiceBox.vue?vue&type=template&id=d939d79e&scoped=true&"
import script from "./ExamChoiceBox.vue?vue&type=script&lang=js&"
export * from "./ExamChoiceBox.vue?vue&type=script&lang=js&"
import style0 from "./ExamChoiceBox.vue?vue&type=style&index=0&id=d939d79e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d939d79e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/Coding/farmerspace/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCheckbox } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VBtn,VCheckbox,VContainer,VFlex,VLayout})
